import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Grid from "@material-ui/core/Grid";

import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {GoogleDriveService} from "../../../../services/GoogleDriveService/GoogleDriveService";
import {BotonAccionAbrirModal, BotonAccionFooterModal, TituloHeaderModal} from "../../../Include/MiniComponents/GlobalComponent";
import {DropzoneArea} from 'material-ui-dropzone';
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";


class ModalGoogleDrive extends Component {
	
	state = {};
	
	showSnackBars = this.props.showSnackBars;
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			files: []
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			},
			files: []
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		this.setState({
			modal: {
				open: true
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	handleChangeDropzoneArea = (files) => {
		this.setState({
			files: files
		});
	};
	
	fileToBase64 = (file) => {
		return new Promise((resolve, reject) => {
			let fileReader = new FileReader();
			fileReader.onload = (r) => {
				resolve({
					nombre: file.name,
					archivo: r.target.result,
					ruta: this.props.ruta || '',
					parent_id: this.props.parent_id || ''
				});
			};
			fileReader.onerror = () => {
				reject({mensaje: 'No se pudo leer el archivo ' + file.name});
			};
			fileReader.readAsDataURL(file);
		});
	};
	
	save = () => {
		if (!this.state.files || this.state.files.length === 0) {
			this.showSnackBars('error', 'Selecciona al menos un archivo.');
			return;
		}
		
		Promise.all(this.state.files.map((file) => this.fileToBase64(file))).then((archivos) => {
			GoogleDriveService.Agregar({
				ruta: this.props.ruta || '',
				parent_id: this.props.parent_id || '',
				archivos: archivos
			}).then((response) => {
				this.close();
				this.props.RefreshList();
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	add = () => {
		this.setState({
			files: []
		});
		this.open();
	};
	
	edit = () => {
		this.open();
	};
	
	view = () => {
		this.open();
	};
	
	render() {
		
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={''}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'md'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'archivo Google Drive'}
						/>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={1}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<DropzoneArea
									onChange={this.handleChangeDropzoneArea.bind(this)}
									open={this.state.open}
									filesLimit={10}
									dropzoneText={'Arrastre y suelte un archivo aquí o haga clic'}
									acceptedFiles={[]}
									showPreviews={false}
									maxFileSize={52428800}
									showAlerts={false}
									showFileNames={true}
									showFileNamesInPreview={true}
								/>
							
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						
						<BotonAccionFooterModal
							id={''}
							tipo={this.state.tipo}
							close={this.close}
							save={this.save}
						/>
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalGoogleDrive.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	ruta: PropTypes.string,
	parent_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalGoogleDrive;
